import darkLogo from 'resources/default-dark.png'

export const defaultLightLogo =
  'https://storage.googleapis.com/buildtoriot-prod-cdn/group-1756_3x.png'
export const defaultDarkLogo = darkLogo
export const defaultDiscoverBackground =
  'https://storage.googleapis.com/buildtoriot-prod-cdn/background.d684bebb.png'
export const defaultLoginBackground =
  'https://storage.googleapis.com/buildtoriot-prod-cdn/background-welcome.d5ddcecb.png'
